import { Auth } from 'aws-amplify';
import getToken from './getToken';

const request = async ({
  uri,
  options,
}) => {
  const host = process.env.REACT_APP_BASE_API_URL || 'https://commerce-api-dev.purple.com';
  try {
    const token = getToken();
    await Auth.currentSession();
    const authHeader = {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${token}`,
      },
      ...options.body,
    };
    const req = await fetch(`${host}/${uri}`, authHeader);
    const res = await req.json();
    return res;
  } catch (error) {
    return error;
  }
};

export default request;
